// React
import React, { useCallback } from 'react'

// Utils
import { classNames } from '@supermeme-ai/utils'

// Components
import { CustomLoader } from './custom-loader'

// External
import { useDropzone } from 'react-dropzone'
import { isDesktop } from 'react-device-detect'
import { UploadCloudIcon } from 'lucide-react'

type FileUploadProps = {
  disabled: boolean
  onFileAccepted: (file: any) => void
  large?: boolean
  loading?: boolean
}

const FileUpload: React.FC<FileUploadProps> = ({
  disabled,
  onFileAccepted,
  large = false,
  loading = false,
}) => {
  const onDrop = useCallback(
    (acceptedFiles) => onFileAccepted(acceptedFiles[0]),
    [onFileAccepted]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFiles: 1,
    multiple: false,
  })

  let dropText = 'Choose Image'
  if (isDesktop) {
    dropText = isDragActive ? 'Drop the files here' : 'Upload or Drag & Drop'
  }

  return (
    <div
      className={classNames(
        'relative flex cursor-pointer items-center justify-center rounded-md border-2 border-dashed p-5',
        isDragActive ? 'bg-gray-100' : '',
        isDragActive ? 'border-gray-400' : 'border-gray-300',
        large ? 'h-full' : ''
      )}
      {...getRootProps()}
    >
      <input disabled={disabled} {...getInputProps()} />
      <UploadCloudIcon className='mr-3 h-7 w-7' />
      <p>{dropText}</p>

      {loading && (
        <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-50'>
          <CustomLoader />
        </div>
      )}
    </div>
  )
}

export { FileUpload }
